import { z } from 'zod';

export const predicateSchema = z.object({
  dsl: z.string().optional(),
  dslHuman: z.string().optional(),
});
